import { toast } from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import { request } from '@core/api/request';
import type { TBankAccount } from '@shared/types/bank-account';
import { queryClient } from '@core/api/query-client';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';
import type { IInitialBankValues } from '../edit-bank-info/interfaces';

export const editBankInfo = async ({
  id,
  ...values
}: IInitialBankValues): Promise<TBankAccount> => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { logo, ...body } = values;

  return await request({
    url: `bank-accounts/${id}/`,
    method: 'PATCH',
    body,
  });
};

export const useEditBankInfo = () => {
  return useMutation({
    mutationFn: editBankInfo,

    onSuccess: () => {
      toast.success('Bank info has updated successfully.');
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.getBankInfo],
      });
    },
  });
};
